





















































import { Vue, Component } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import InternationalizationService from '@/api/InternationalizationService';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import BusinessOperateSelect from '@/componentsV2/organisms/BusinessOperateSelect/BusinessOperateSelect.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { EInternationalizationStatus } from '@/models/internationalization';

import { scrollToTop } from '@/utils/scrollToTop';

import { OnboardingURL } from '@/views/Onboarding/helpers';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    BusinessOperateSelect,
    CloseModalIcon,
    Typography
  }
})
export default class YourStoreOperation extends Vue {
  internationalizationService = new InternationalizationService();

  formData = {
    operationType: this.defaultOperationType
  };

  loading = false;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get defaultOperationType() {
    const countryOperation = this.yourStoreFormData.country.status;

    if (countryOperation === EInternationalizationStatus.ONLINE_ONLY) {
      return IBusinessType.ONLINE;
    }

    return this.yourStoreFormData.operationType;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      this.$notification(
        String(this.$t('common.alerts.highlightedItemsError')),
        'error'
      );

      return;
    }

    this.$store.dispatch(
      'businessOnboarding/SET_OPERATION_TYPE',
      this.formData.operationType
    );

    if (this.formData.operationType === IBusinessType.ONLINE) {
      this.$router.push(OnboardingURL.YOUR_BUSINESS_PROVIDERS);
      return;
    }

    this.$router.push(OnboardingURL.YOUR_BUSINESS_ADDRESS);
  }

  goBack() {
    this.$router.push(OnboardingURL.YOUR_BUSINESS);
  }

  mounted() {
    scrollToTop('bo-base-layout__right');
  }
}
